export type MessageBoxType = 'details' | 'info' | 'danger' | 'warn' | 'drawdown-submitted' | 'promo-style1' | 'promo-style2' | 'disable' | 'success';
